import zingworks_logo from "../../assets/whitelabel_website/zingworks_logo.svg";
export const LogoList = [
    {
        company_name: "zingworks",
        logo: zingworks_logo,
    }
];